import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from './action-sheet';
import {
  AllowedShortcuts,
  KeyboardScope,
} from '@/platform/shortcuts/operator-shortcuts';
import { FulfillmentName } from '@/types';
import { translateFulfillmentType } from '@domain/fulfillment-settings/utils/translate-fulfillment-type';
import { useKeyboardShortcuts } from '@platform/shortcuts/hooks/use-keyboard-shortcuts';
import { useOfflineModeActive } from '@/hooks/use-offline-mode-active';

export interface Props {
  fulfillmentType: FulfillmentName;
  isVisible: boolean;
  onClose: () => void;
  onConfirmDeliveryDate: () => void;
  onEditDeliveryDate: () => void;
}

export const SameDayConfirmationActionSheet: React.FC<Props> = ({
  onClose,
  onConfirmDeliveryDate,
  onEditDeliveryDate,
  isVisible,
  fulfillmentType,
}) => {
  const isOfflineModeActive = useOfflineModeActive();

  useKeyboardShortcuts(
    AllowedShortcuts.PlaceOrder,
    onConfirmDeliveryDate,
    [],
    {},
    true,
    KeyboardScope.ACTION_SHEET,
  );

  return (
    <ActionSheet
      actions={[
        i18n.t(
          isOfflineModeActive
            ? 'same_day_confirmation.queue_order'
            : 'same_day_confirmation.place_order',
        ),
        translateFulfillmentType(
          fulfillmentType,
          'same_day_confirmation.edit_date',
        ),
      ]}
      isFocusableForKeyboardShortcuts
      isVisible={isVisible}
      message={translateFulfillmentType(
        fulfillmentType,
        'same_day_confirmation.message',
      )}
      onAction={async (_, index) => {
        if (index === 0) {
          Analytics.track(
            isOfflineModeActive
              ? 'same_day_confirmation_action_sheet.queue_order_button.press'
              : 'same_day_confirmation_action_sheet.place_order_button.press',
          );
          onConfirmDeliveryDate();
        } else {
          onEditDeliveryDate();
          Analytics.track(
            'same_day_confirmation_action_sheet.edit_date_button.press',
          );
        }
      }}
      onClose={onClose}
      title={translateFulfillmentType(
        fulfillmentType,
        'same_day_confirmation.title',
      )}
    />
  );
};
